import * as styles from "./MenuItem.css";
import { ComponentPropsWithoutRef } from "react";
// @ts-ignore
import ChevronRight from "@material-design-icons/svg/filled/chevron_right.svg?react";
// @ts-ignore
import Add from "@material-design-icons/svg/filled/add.svg?react";
// @ts-ignore
import Remove from "@material-design-icons/svg/filled/remove.svg?react";
// @ts-ignore
import ArrowOutward from "@material-design-icons/svg/filled/arrow_outward.svg?react";

type MenuItemProps = ComponentPropsWithoutRef<"div"> & {
  hasItems?: boolean;
  isOpen?: boolean;
  layout?: "default" | "reverse";
};

export const MenuItem = ({
  children,
  hasItems,
  layout = "default",
  isOpen,
  ...props
}: MenuItemProps) => {
  return (
    <div {...props} className={styles.item({ isOpen: isOpen, layout: layout })}>
      {children}
      <div className={styles.icon}>
        {layout == "reverse" ? (
          <ArrowOutward className={styles.arrowOutward} />
        ) : hasItems ? (
          isOpen ? (
            <Remove />
          ) : (
            <Add />
          )
        ) : (
          <ChevronRight />
        )}
      </div>
    </div>
  );
};
